//#region src/utils/event.ts
function noop() {}
//#endregion
export { noop };

//# sourceMappingURL=event.js.map